import { API_URL } from '@/constants/env'

import type { OpportunityType } from '@/types/Opportunity'
import type { SearchOut } from '@/types/Search'

/**
 * Maps opportunity types to their API endpoint paths
 */
const ENDPOINT_MAP: Record<OpportunityType, string> = {
  federal_contract: 'federal-contracts',
  federal_grant: 'federal-grants',
  sbir: 'sbirs',
  sled_contract: 'sled-contracts',
  dibbs_contract: 'dibbs-contracts',
}

/**
 * Fetches similar opportunities for a given opportunity type and ID
 *
 * Pure async function - no side effects, suitable for react-query queryFn
 *
 * @param type - The opportunity type (federal_contract, federal_grant, etc.)
 * @param id - The opportunity ID
 * @returns Array of similar opportunities (SearchOut[])
 * @throws Response object on HTTP error
 */
export async function fetchSimilarOpportunities(
  type: OpportunityType,
  id: string,
): Promise<SearchOut[]> {
  if (id === '') {
    return []
  }

  const endpoint = ENDPOINT_MAP[type]
  if (!endpoint) {
    console.warn(`Unknown opportunity type: ${type}`)
    return []
  }

  const url = `${API_URL}/api/v1/${endpoint}/${id}/similar`

  const response = await fetch(url, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  })

  if (!response.ok) {
    throw response
  }

  return response.json()
}
